module.exports = __webpack_public_path__ + "img/xinliuPic.ee653b66.svg";